<template>
  <ValidationObserver ref="observer" novalidate>
    <div class="ml-2 mr-2 mt-n3">
      <CustomCollapse id="serviceDocumentAdd" class="mt-2">
        <CustomCollapseItem
          parent-id="serviceDocumentAdd"
          title="Añadir Documento"
          :selected="true"
          expanded
        >
          <div class="row">
            <div class="col-md-4">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomDropDown
                  v-model="info.document"
                  label="Documento:"
                  placeholder="Seleccione"
                  fieldkey="id"
                  fieldname="name"
                  :error="errors[0]"
                  custom-error-msg=""
                  :options="[]"
                  class="w-75"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-4 w-100">
              <BoxIconButton
                v-if="!fileUploaded"
                title="Presione aquí para anejar"
                icon="fas fa-file-plus"
                label="Archivo:"
                class="box-icon-button-custom"
                onclick="document.getElementById('fileInput').click()"
              />
              <span v-if="showMessageDocument" class="danger-text">
                Favor de anejar el documento.
              </span>

              <input
                id="fileInput"
                type="file"
                style="display:none"
                @change="openUploadFile"
              />

              <div v-if="fileUploaded">
                <label for="" class="d-block mt-1">Archivo:</label>
                <div class="mt-n3">
                  <label for="" class="mr-3">{{ info.document }}</label>
                  <ActionButton
                    i="fas fa-file-download"
                    variant="outline-success m-1 pl-3"
                    @click="downloadFile"
                  />

                  <ActionButton
                    i="fas fa-times-circle"
                    variant="outline-danger m-1 pl-3"
                    @click="cancelSelectedFile"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-4 mt-3 text-right">
              <ActionButton variant="success m-2 pl-4 pr-4" @click="addFile">
                Añadir
              </ActionButton>
            </div>
          </div>
        </CustomCollapseItem>
      </CustomCollapse>
    </div>
  </ValidationObserver>
</template>

<script>
import { CustomDropDown, ActionButton } from '@/components/common';
import BoxIconButton from '@/components/pei/shared/BoxIconButton';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import general from '@/services/pei/general';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'ProcessDeterminationDocumentAdd',
  data() {
    return {
      info: {
        name: '',
        category: null,
        files: null,
        document: null,
      },
      fileUploaded: false,
      showMessageDocument: false,
    };
  },
  props: {
    documentTypeList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openUploadFile(e) {
      let self = this;
      self.info.files = e.target.files || e.dataTransfer.files;
      if (self.info.files.length > 0) {
        self.info.document = self.info.files[0].name;
        self.showMessageDocument = false;
        self.fileUploaded = true;
      }
    },
    checkValidation() {
      let self = this;
      let isValid =
        self.info.name !== '' &&
        self.info.category !== null &&
        self.info.files !== null;
      self.showMessageDocument = false;
      if (!self.info.files) self.showMessageDocument = true;

      return isValid;
    },
    async addFile() {
      this.$emit('on-add', { ...this.info });
    },
    cancelFile() {
      this.$emit('on-cancel', { ...this.info });
    },
    downloadFile() {
      let self = this;
      let file = self.info.files[0];
      general.documentDownloadLocalFile(file);
    },
    cancelSelectedFile() {
      let self = this;
      self.info.files = null;
      self.fileUploaded = false;
    },
  },
  components: {
    ActionButton,
    CustomDropDown,
    BoxIconButton,
    CustomCollapse,
    CustomCollapseItem,
    ValidationObserver,
    ValidationProvider,
  },
};
</script>

<style scoped>
.box-icon-button-custom >>> .btn {
  padding: 1px 23px;
  width: 100%;
}

.badge-modal-custom >>> .tag-badge-title {
  font-size: 20px;
}

.danger-text {
  color: #e85c5c;
}

#serviceDocumentAdd >>> .tag-badge-pei {
  margin-left: -12px !important;
}
</style>
